
import NavList from '@/components/common/NavList.vue'
import OemLearnMore from '@/components/common/OemLearnMore.vue';
import { computed, defineComponent, onBeforeMount, reactive, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import router from '@/router'
import OpenOtherApi from '@/api/OpenOtherApi';
import { ProviderModule } from '@/store/modules/provider.module';

export default defineComponent({
  components: {
    NavList,
    OemLearnMore
  },
  setup () {
    const route = useRoute()
    const id = Number(route.query.id)
    const userId = Number(route.query.userId)
    const activeRoute = ref()
    const engineer = reactive<any>({ user: {} })
    const menuList = computed(() => [
      { name: engineer.user.name || '添加客服', link: '/system_setting/account-add/detail', query: { id, userId } },
      { name: '其他资料', link: '/system_setting/account-add/other', query: { id, userId }, show: userId > 0 },
      { name: '弹性工作时间', link: '/system_setting/account-add/flextime', query: { id, userId }, show: id > 0 }
    ])
    const eweiHelpcenterApiUrl = computed(() => ProviderModule.eweiHelpcenterApiUrl)

    watch(route, (n) => {
      activeRoute.value = n.path.replace('/system_setting/account-add/', '')
    }, {
      immediate: true
    })

    function handleLink (path) {
      router.replace({ path, query: { id, userId: engineer.user.id } })
    }

    function init () {
      if (!id) return
      OpenOtherApi.getEngineerInfo(id).then(res => {
        res.serviceDeskIds = res?.serviceDesks?.map(item => item.id)
        Object.assign(engineer, res)
      })
    }

    onBeforeMount(() => {
      init()
    })

    return {
      menuList,
      eweiHelpcenterApiUrl,
      engineer,
      handleLink
    }
  }
})
